import {Typography} from '../types/typography.types'
import fonts from './fonts'

const primaryDefault = {
    fontFamily: `${fonts.fonts.primary}`,
    fontStyle: 'normal',
    letterSpacing: 0,
}

const secondaryDefault = {
    fontFamily: `${fonts.fonts.secondary}`,
    fontStyle: 'normal',
    letterSpacing: 0,
}

const typography: Typography = {
    textStyles: {
        'display-large': {
            ...primaryDefault,
            // fontSize 48px–64px | lineHeight 36px–64px
            fontSize: 'clamp(3rem, 2.667rem + 1.667vw, 4rem)',
            lineHeight: 'clamp(2.25rem, 1.667rem + 2.917vw, 4rem)',
        },
        'display-small': {
            ...primaryDefault,
            // fontSize 40px–56px | lineHeight 34px–42px
            fontSize: 'clamp(2.5rem, 2.167rem + 1.667vw, 3.5rem)',
            lineHeight: 'clamp(2.125rem, 1.958rem + 0.833vw, 2.625rem)',
        },
        'head-xlarge': {
            ...secondaryDefault,
            // fontSize 32px–40px | lineHeight 34px–38px
            fontSize: 'clamp(2rem, 1.833rem + 0.833vw, 2.5rem)',
            lineHeight: 'clamp(2.125rem, 2.042rem + 0.417vw, 2.375rem)',
        },
        'head-large': {
            ...secondaryDefault,
            // fontSize 28px–32px | lineHeight 30px–32px
            fontSize: 'clamp(1.75rem, 1.667rem + 0.417vw, 2rem)',
            lineHeight: 'clamp(1.875rem, 1.833rem + 0.208vw, 2rem)',
        },
        'head-medium': {
            ...secondaryDefault,
            // fontSize 24px–28px | lineHeight 26px–30px
            fontSize: 'clamp(1.5rem, 1.417rem + 0.417vw, 1.75rem)',
            lineHeight: 'clamp(1.625rem, 1.542rem + 0.417vw, 1.875rem)',
        },
        'head-small': {
            ...secondaryDefault,
            // fontSize 24px | lineHeight 24px–26px
            fontSize: '1.5rem',
            lineHeight: 'clamp(1.5rem, 1.458rem + 0.208vw, 1.625rem)',
        },
        'head-xsmall': {
            ...secondaryDefault,
            //this doesn't exist in the new typography spec, but we need it to avoid regressions
            // fontSize 18px–20px | lineHeight 20px–22px
            fontSize: ' clamp(1.125rem, 1.083rem + 0.208vw, 1.25rem)',
            lineHeight: 'clamp(1.25rem, 1.208rem + 0.208vw, 1.375rem)',
        },
        'body-xxlarge': {
            ...secondaryDefault,
            // fontSize 22px | lineHeight 28px
            fontSize: '1.375rem',
            lineHeight: '1.375rem',
        },
        'body-xlarge': {
            ...secondaryDefault,
            // fontSize 20px | lineHeight 26px
            fontSize: '1.25rem',
            lineHeight: '1.625rem',
        },
        'body-large': {
            ...secondaryDefault,
            // fontSize 18px | lineHeight 22px
            fontSize: '1.125rem',
            lineHeight: '1.375rem',
        },
        'body-medium': {
            ...secondaryDefault,
            // fontSize 16px | lineHeight 18px
            fontSize: '1rem',
            lineHeight: '1.12rem',
        },
        'body-small': {
            ...secondaryDefault,
            // fontSize 14px | lineHeight 18px
            fontSize: '0.875rem',
            lineHeight: '1.12rem',
        },
        'body-xsmall': {
            ...secondaryDefault,
            // fontSize 12px | lineHeight 14px
            fontSize: '0.75rem',
            lineHeight: '0.875rem',
        },
        'body-xxsmall': {
            ...secondaryDefault,
            // fontSize 10px | lineHeight 12px
            fontSize: '0.625rem',
            lineHeight: '0.75rem',
        },
    },
}

export default typography
